export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000/v1';

// WebSocket URL. A build-time REACT_APP_WS_URL is honoured ONLY if it isn't a
// localhost value — a prior build baked `ws://localhost/socket.io`, which made
// every production client try to socket.io to its OWN machine (ERR_CONNECTION_
// REFUSED) and silently disabled live updates. When unset / localhost, connect
// SAME-ORIGIN (nginx proxies /socket.io/ → backend) so it just works on any host.
const rawWs = process.env.REACT_APP_WS_URL;
export const WS_URL = (rawWs && !/localhost|127\.0\.0\.1|0\.0\.0\.0/.test(rawWs))
  ? rawWs
  : (typeof window !== 'undefined' ? window.location.origin : 'http://localhost:3000');

// Production-readiness audit — fail loudly if a production build was
// shipped without REACT_APP_API_URL / REACT_APP_WS_URL set (CRA bakes env
// vars at build time, so a missed flag silently falls back to localhost
// and every API call dies).  We can't throw at module load (the login
// page must still render so the user knows what's wrong), but we surface
// a banner via console + a global flag the auth UI checks.
declare global {
  interface Window { __EARNGUSH_API_MISCONFIG__?: string; }
}
if (typeof window !== 'undefined') {
  const onProdHost = !['localhost', '127.0.0.1', '0.0.0.0'].some(h => window.location.hostname.includes(h));
  const looksLikeLocalhost = /localhost|127\.0\.0\.1|0\.0\.0\.0/.test(`${API_BASE_URL} ${WS_URL}`);
  if (onProdHost && looksLikeLocalhost) {
    const msg = `Frontend was built without REACT_APP_API_URL / REACT_APP_WS_URL — every API call will fail. Set those build args and redeploy.`;
    window.__EARNGUSH_API_MISCONFIG__ = msg;
    // eslint-disable-next-line no-console
    console.error(`[earngush] ${msg}`);
  }
}

// USD→INR conversion factor used to express Delta Exchange (USD-quoted)
// risk / gain / notional figures in rupees on the dashboards and charts.
// Centralised here (was a scattered `? 85 : 1` literal) and overridable at
// build time via REACT_APP_USD_INR so the rate can be tuned without code edits.
export const USD_TO_INR = Number(process.env.REACT_APP_USD_INR) || 85;

export const TOKEN_KEY = 'token';
export const REFRESH_TOKEN_KEY = 'refreshToken';
export const USER_KEY = 'user';

export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  REGISTER: '/register',
  DASHBOARD: '/dashboard',
  TRADES: '/trades',
  ORDERS: '/orders',
  ALERTS: '/alerts',
  INSTRUMENTS: '/instruments',
  SETTINGS: '/settings'
};

export const ORDER_TYPES = [
  { value: 'MARKET', label: 'Market Order' },
  { value: 'LIMIT', label: 'Limit Order' },
  { value: 'STOP', label: 'Stop Order' },
  { value: 'STOP_LIMIT', label: 'Stop Limit Order' }
];

export const ALERT_PRIORITIES = [
  { value: 'HIGH', label: 'High', color: 'error' },
  { value: 'MEDIUM', label: 'Medium', color: 'warning' },
  { value: 'LOW', label: 'Low', color: 'info' }
];

export const CHART_PERIODS = [
  { value: '1D', label: '1 Day' },
  { value: '1W', label: '1 Week' },
  { value: '1M', label: '1 Month' },
  { value: '3M', label: '3 Months' },
  { value: '1Y', label: '1 Year' }
];
